import { Routes, Route } from "react-router-dom";

import Home from "./Home/Home";
import RecipeDetails from "./RecipeDetails/RecipeDetails";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import Navbar from "./Home/Navbar";
import AdminLogin from "./Admin/adminlogin";
import ProtectedRoute from "./ProtectedRoute";

function Router() {
  return (
    <>
     <Navbar />
      <Routes>
        {/* LOGIN */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/recipe-details/:id"
          element={
            <ProtectedRoute>
              <RecipeDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

      </Routes>

    </>
  );
}

export default Router;